import {
  breakpointSizes,
  getBreakpointOnly,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import { Location } from 'history'
import React from 'react'
import Box from 'src/components/Box/Box'
import LoadingBoxBottom from 'src/components/LoadingBoxBottom/LoadingBoxBottom'
import SvgArrowForward from 'src/components/Svgs/SvgArrowForward'
import Lnk from 'src/navigation/Lnk'
import { LocationState } from 'src/redux/createRootReducer'
import { css } from 'styled-components'

export type NavAwayProps = NavAwayPropsAriaSource | NavAwayPropsAriaLabel

interface NavAwayPropsShared {
  to: Location<LocationState> | string
  label: React.ReactElement
  id?: string
}

interface NavAwayPropsAriaSource extends NavAwayPropsShared {
  ariaLabelSource: string
  ariaLabel?: undefined
}

interface NavAwayPropsAriaLabel extends NavAwayPropsShared {
  ariaLabel: string
  ariaLabelSource?: undefined
}

interface NavAwayBoxProps {
  className?: string
  navAway?: NavAwayProps
  loading?: boolean
}

const NavAwayBox: React.FC<React.PropsWithChildren<NavAwayBoxProps>> = (
  props,
): React.ReactElement => {
  return (
    <Box className={props.className} noPadding noShadow outlineBorder>
      {props.children}
      {props.navAway !== undefined && !props.loading && (
        <Lnk
          id={props.navAway.id ? props.navAway.id : 'link'}
          className={'nav-away'}
          to={props.navAway.to}
          {...(props.navAway.ariaLabelSource !== undefined
            ? { ariaLabelSource: props.navAway.ariaLabelSource }
            : { ariaLabel: props.navAway.ariaLabel })}
          css={css`
            background-color: ${styleConstants.colors.gray_lightest};
            border-bottom-left-radius: ${styleConstants.borderRadius.box};
            border-bottom-right-radius: ${styleConstants.borderRadius.box};
            display: flex;
            justify-content: flex-end;
            align-items: center;
            padding: 20px ${styleConstants.widths.cardPaddingXSMUp};
            cursor: pointer;
            transition: background-color ${styleConstants.transitionSpeed.fast}
              ease-out;

            ${getBreakpointOnly(breakpointSizes.XXSM)(css`
              padding: 20px ${styleConstants.widths.cardPaddingXXSMOnly};
            `)}

            span {
              transition: color ${styleConstants.transitionSpeed.medium}
                ease-out;
            }

            svg path {
              transition: fill ${styleConstants.transitionSpeed.fast} ease-out;
            }

            &:hover {
              background-color: ${themeConstants.colors.cta};

              span {
                color: ${styleConstants.colors.white};
              }

              svg path {
                fill: ${styleConstants.colors.white};
              }
            }
          `}
        >
          <span
            css={css`
              ${getFontCss(
                14,
                themeConstants.colors.cta,
                styleConstants.fontFamilies.medium,
              )}
            `}
          >
            {props.navAway.label}
          </span>
          <SvgArrowForward
            className={'arrow-forward'}
            css={css`
              transform: scale(calc(18 / 24));
              transition: transform ${styleConstants.transitionSpeed.fast}
                ease-out;
            `}
          />
        </Lnk>
      )}
      {props.loading && <LoadingBoxBottom />}
    </Box>
  )
}

export default NavAwayBox
